module.exports = __webpack_public_path__ + "static/media/phet-simulator.png";